The personal details of the uploaded candidate to be updated.

At least one email address is required in `communication`,
and one of the provided values must match `seekPrimaryEmailAddress`.

If no value is provided for physical addresses in `communication` it will be treated as an empty list and will remove any previously uploaded addresses.
